/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityTypeEnum } from './EntityTypeEnum';
import {
    EntityTypeEnumFromJSON,
    EntityTypeEnumFromJSONTyped,
    EntityTypeEnumToJSON,
    EntityTypeEnumToJSONTyped,
} from './EntityTypeEnum';

/**
 * Represents a link to an entity referenced in an activity feed message
 * @export
 * @interface ActivityFeedEntityLinkDto
 */
export interface ActivityFeedEntityLinkDto {
    /**
     * 
     * @type {EntityTypeEnum}
     * @memberof ActivityFeedEntityLinkDto
     */
    entityType: EntityTypeEnum;
    /**
     * Unique identifier of the referenced entity
     * @type {string}
     * @memberof ActivityFeedEntityLinkDto
     */
    entityId: string;
    /**
     * Display label for the entity link (e.g., contract number, person name)
     * @type {string}
     * @memberof ActivityFeedEntityLinkDto
     */
    entityLabel: string;
}



/**
 * Check if a given object implements the ActivityFeedEntityLinkDto interface.
 */
export function instanceOfActivityFeedEntityLinkDto(value: object): value is ActivityFeedEntityLinkDto {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('entityLabel' in value) || value['entityLabel'] === undefined) return false;
    return true;
}

export function ActivityFeedEntityLinkDtoFromJSON(json: any): ActivityFeedEntityLinkDto {
    return ActivityFeedEntityLinkDtoFromJSONTyped(json, false);
}

export function ActivityFeedEntityLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityFeedEntityLinkDto {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': EntityTypeEnumFromJSON(json['entityType']),
        'entityId': json['entityId'],
        'entityLabel': json['entityLabel'],
    };
}

export function ActivityFeedEntityLinkDtoToJSON(json: any): ActivityFeedEntityLinkDto {
    return ActivityFeedEntityLinkDtoToJSONTyped(json, false);
}

export function ActivityFeedEntityLinkDtoToJSONTyped(value?: ActivityFeedEntityLinkDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': EntityTypeEnumToJSON(value['entityType']),
        'entityId': value['entityId'],
        'entityLabel': value['entityLabel'],
    };
}

